import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import { Link } from 'react-router-dom';

import Image from '../elements/Image';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const ProductDetails = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

   function buttonOnClick ()
  {

    alert('Please make sure to Indicate that your Message is in regards to the WorkBounty Program.');

  }

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = {
    title: 'Product',
    paragraph: 'The MobileSense Product Page, Solving Your Fluid Analysis Needs. Designed to Test Your Solvent or Electrolyte Chemistry'
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>


            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Our MobileSense Machine
                  </div>
                <h3 className="mt-0 mb-12">
                  MobileSense Product and Software
                  </h3>
                <p className="m-0">
                Solves the Problem of Fluid Management, with Fluid Scanning using our Patented SERS Spectroscopy Technique.</p>
              </div>
                <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/mobilesense-urinehealth.jpg')}
                  alt="Data Visualized Raman 01"
                  width={528}
                  height={396} />
              </div>
            </div>



            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Lightning fast workflow
                  </div>
                <h3 className="mt-0 mb-12">
                  High Quality Data
                  </h3>
                <p className="m-0">
                  SERS Spectroscopy uses light to interrogate fluids,direct optical chemical detection. This technique has advantages over other sensing techniques.

                  </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/output-report-mobilesense.jpg')}
                  alt="Data Visualized Raman 01"
                  width={528}
                  height={396} />
              </div>
            </div>








            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Your Fluid Analysis Partner
                  </div>
                <h3 className="mt-0 mb-12">
                  Let Us Be Your Fluid Analysis Partner. Problem Solved
                  </h3>
                <p className="m-0">
                  There is a goldmine of information waiting to be discovered, on the quest for human health sciences to abundant energy!
                  </p>

                <Link to={'/contact'} >
                <button className="button button-primary button-wide-mobile button-sm" onClick={buttonOnClick}> Contact </button>
                </Link>


              </div>
            </div>










            

          </div>
        </div>
      </div>
    </section>
  );
}

ProductDetails.propTypes = propTypes;
ProductDetails.defaultProps = defaultProps;

export default ProductDetails;